var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgD(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1637,
    height: 254,
    viewBox: "0 0 1637 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000102282 4.05772V-1.04232e-06L1514.11 -1.04232e-06L1636.9 250.79V253.799L1511.98 4.05772L-0.000102282 4.05772Z",
    fill: "url(#paint0_linear_250_13812)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000102282 4.05772V-1.04232e-06L1514.11 -1.04232e-06L1636.9 250.79V253.799L1511.98 4.05772L-0.000102282 4.05772Z",
    fill: "url(#paint1_linear_250_13812)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_250_13812",
    x1: 1603.57,
    y1: 88.5619,
    x2: 0.156301,
    y2: 88.5619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DCDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1908,
    stopColor: "#1DC5C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#1CAEC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8639,
    stopColor: "#1A89CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#197ACF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_250_13812",
    x1: 818.45,
    y1: 253.799,
    x2: 801.117,
    y2: 38.1047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FC5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D80AF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgD);
export default __webpack_public_path__ + "static/media/d.f35b3c2574aab6d06d9e4cf445124b34.svg";
export { ForwardRef as ReactComponent };